import React, { Component } from 'react';
import { connect } from 'react-redux';
import marked from 'marked';
import './AboutUs.css';

class AboutUs extends Component {
  
  render () {
    const pageAboutUs = this.props.pages.filter(page => page.name === 'about_us');

    if(pageAboutUs.length > 0){
      return <div
        className="about-us inner-container"
        dangerouslySetInnerHTML={{ __html: marked(pageAboutUs[0].content) }}
      />
    }else{
      return null;
    }

    // return (
    //   <div className="about-us inner-container">
    //     <div className="columns about-us-title">
    //       <div className="column">
    //         <h1 className="main-color  large-letter-spacing">德商美最時</h1>
    //         <h2 className="main-color">Since 1806</h2>
    //       </div>
    //       <div className="column">
    //         <h3 className="text-align-right">享譽全球、獨一無二、</h3>
    //         <h3 className="text-align-right">總部位於德國不來梅、</h3>
    //         <h3 className="text-align-right">是一家私營性質的合夥企業。</h3>
    //       </div>
    //     </div>
        

    //     <div className="columns">
    //       <div className="column about-us-side">
    //       <img src="http://li1861-248.members.linode.com:1337/uploads/65e241f0865a4508b02704b189e7e8bf.jpg"/>
    //         <h2>美最時簡介</h2>
    //         <div className="about-title-separater" />
    //         <h4>擁有豐富的經驗、先進的技術、</h4>
    //         <h4>在開發銷售或採購市場方面提供支援和協助</h4>
    //       </div>
    //       <div className="column about-us-content">
    //         <p>我們的服務涵蓋整個價值鏈，從產品規劃開發、製造、銷售和零售到市場營銷及售後服務一應俱全。其他業務領域包括亞洲進出口和亞洲國家內部貿易。</p>
    //         <p>200多年的全球營運經驗 (其中包括150年的亞洲貿易)以及結構靈活的全球網絡是我們成功的基石。</p>
    //         <p>我們位於全世界的分公司皆具備針對所服務的特定市場和客戶進行業務運營的能力，這種獨立和靈活的運作模式使我們能將各種新型產品及行業完美納入美最時公司，從而成功實現您的企業目標。</p>
    //         <div className="about-us-video">
    //           <iframe title="Melchers Trading" width="100%" height="100%" src="https://www.youtube.com/embed/EZiQgDegd1o" frameBorder="0" allow="autoplay; encrypted-media" allowFullScreen></iframe>
    //         </div>
    //       </div>
    //     </div>

    //     <div className="about-us-separater"/>

    //     <div className="columns">
    //       <div className="column about-us-side">
    //         <img src="http://li1861-248.members.linode.com:1337/uploads/2808c03fff8f4252a9759ac90d0032cd.jpg"/>
            
    //         <h2>代理STIHL</h2>
    //         <div className="about-title-separater" />
    //         <h4>德商美最時貿易公司於1997年起</h4>
    //         <h4>
    //           <span>代理世界第一鏈鋸品牌-STIHL</span><sup>®</sup>
    //         </h4>
    //       </div>
    //       <div className="column about-us-content">
    //         <p>自1997年來，美最時公司藉由豐富的產品與客戶開發經驗開始代理德國STIHL品牌在台灣的發展與銷售，期間更因應客戶需求及市場動態，陸續引進STIHL自用型及專業型的割草機、籬笆剪、噴霧機、吹葉機、切割機、高壓清洗機等專業動力工具。近年更有環保、低噪音、低污染的電池及插電機種以滿足不同環境需求及使用者使用。</p>
    //         <p>除了致力於銷售通路的維持與拓展外，更比照STIHL規格提供了完善的維修及售後服務，並與STIHL持續地交流與交換產品與市場相關訊息，以期能提供客戶最好的使用體驗。</p>
    //         <div className="about-us-image-2">
    //           <img src="http://li1861-248.members.linode.com:1337/uploads/06bf579e274e4001bdbb1828e40d6d24.jpg"/>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // )
  }
}

const mapStateToProps = state => ({
  pages: state.pages,
});

export default connect(mapStateToProps)(AboutUs);


// WEBPACK FOOTER //
// ./src/components/AboutUs.js